import ChartPanels from './ChartPanels';

const RequestsByComp = () => (
  <div className='flex flex-col border border-neutral-lighter-two rounded-lg shadow-allocation-table w-full'>
    <ChartPanels />
  </div>
);

export default RequestsByComp;
